export const EMPLOYEE_DEFAULTS = {
    CREATED_BY: "ADMIN",

    TITLE: "Mr.",

    IS_ACTIVE: true,
    IS_SYSTEM_USER: false,

    NATIONALITY_ID: 1,
    BLOOD_GROUP_ID: 1,

    COUNTRY_ID: 1,
    PROVINCE_ID: 2,
    DISTRICT_ID: 2,

    ACCOUNT_NAME: "N/A",
    ACCOUNT_TYPE: "Savings",

    QUALIFICATION_COUNTRY: "Sri Lanka",

    PERMANENT_ADDRESS_TYPE: "P",
    CURRENT_ADDRESS_TYPE: "C",

    QUALIFICATION_TYPES: {
        NON_TECHNICAL: 1,
        PROFESSIONAL: 2,
        TECHNICAL: 3,
    },
};